import React from 'react';
import './LZPrivacySDKListPage.css';

class LZPrivacySDKListPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }
    
    render() {
        return (
            <>
                <div className='main-header'>莱泽之家第三方SDK说明</div>
                <div className='header-content'>为保障莱泽之家App的稳定运行或实现相关功能，我们可能会接入由第三方提供的软件开发包(SDK)实现前述目的。我们会尽到审慎义务，对合作方获取信息的SDK进行严格的安全监测，以保护数据安全。</div>
                <div className='header-content'>我们接入的第三方SDK主要服务于您以及其他的用户的需求，因此在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方SDK。我们会及时在本说明中向您公开说明接入第三方SDK的最新情况。目前莱泽之家App接入的第三方SDK列明如下:</div>
                <br/>
                <div className='table-header'>安卓操作系统第三方SDK列表</div>
                <table className='table-sdklist' cellSpacing={0} cellPadding={0}>
                    <thead>
                        <tr>
                            <td>产品/类型</td>
                            <td>使用目的</td>
                            <td>使用场景</td>
                            <td>个人信息收集类型</td>
                            <td>收集方式</td>
                            <td>第三方公司名称</td>
                            <td>隐私保护说明</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>华为推送</th>
                            <th>用于消息推送</th>
                            <th>消息提醒更新时</th>
                            <th>设备信息（IMEI、AndroidID）、应用列表</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>华为技术有限公司</th>
                            <th><a href={'https://consumer.huawei.com/cn/privacy/privacy-policy/'} target={"_blank"} rel="noreferrer">华为隐私政策</a></th>
                        </tr>
                        <tr>
                            <th>小米推送</th>
                            <th>用于消息推送</th>
                            <th>消息提醒更新时</th>
                            <th>设备信息（IMEI、AndroidID）、应用列表</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>小米移动软件有限公司</th>
                            <th><a href={'https://dev.mi.com/console/doc/detail?pId=1822'} target={"_blank"} rel="noreferrer">小米隐私政策</a></th>
                        </tr>
                        <tr>
                            <th>VIVO推送</th>
                            <th>用于消息推送</th>
                            <th>消息提醒更新时</th>
                            <th>设备信息（IMEI、AndroidID）、应用列表</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>维沃移动通信有限公司</th>
                            <th><a href={'https://www.vivo.com.cn/about-vivo/privacy-policy'} target={"_blank"} rel="noreferrer">VIVO隐私政策</a></th>
                        </tr>
                        <tr>
                            <th>OPPO推送</th>
                            <th>用于消息推送</th>
                            <th>消息提醒更新时</th>
                            <th>设备信息（IMEI、AndroidID）、应用列表</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>广州欢太科技有限公司</th>
                            <th><a href={'https://open.oppomobile.com/new/developmentDoc/info?id=10288'} target={"_blank"} rel="noreferrer">OPPO隐私政策</a></th>
                        </tr>
                        <tr>
                            <th>支付宝</th>
                            <th>可帮助用户完成付款、提供安全认证服务</th>
                            <th>支付宝登录、订单付款时</th>
                            <th>设备信息（IMSI、IMEI、MAC地址、AndroidID、传感器信息、ICCID）、位置信息、应用列表、外部存储</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>支付宝（中国）网络技术有限公司</th>
                            <th><a href={'https://render.alipay.com/p/c/k2cx0tg8'} target={"_blank"} rel="noreferrer">支付宝隐私政策</a></th>
                        </tr>
                        <tr>
                            <th>微信</th>
                            <th>可帮助用户完成付款、提供安全认证服务</th>
                            <th>微信登录、订单付款和分享到微信时</th>
                            <th>基础设备信息、app信息</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>深圳市腾讯计算机系统有限公司</th>
                            <th><a href={'https://privacy.qq.com/document/priview/bdf936b2477a45ff86da57e3d988bc2b'} target={"_blank"} rel="noreferrer">腾讯隐私政策</a></th>
                        </tr>
                        <tr>
                            <th>腾讯bugly</th>
                            <th>可收集APP闪退时刻的设备信息，以便于帮助我们分析闪退原因为您提供更好的使用体验</th>
                            <th>APP发生闪退时</th>
                            <th>基础设备信息、app信息</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>深圳市腾讯计算机系统有限公司</th>
                            <th><a href={'https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56'} target={"_blank"} rel="noreferrer">Bugly隐私政策</a></th>
                        </tr>
                        <tr>
                            <th>环信</th>
                            <th>可用于客服为用户提供售前/售后咨询服务</th>
                            <th>打开客服聊天页面时</th>
                            <th>基础设备信息（AndroidID、设备硬件类型、设备型号、设备系统类型）、app信息</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>北京亿思摩博网络科技有限公司</th>
                            <th><a href={'https://www.easemob.com/protocol'} target={"_blank"} rel="noreferrer">环信隐私政策</a></th>
                        </tr>
                    </tbody>
                </table>
                <br/>
                <div className='table-header'>iOS操作系统第三方SDK列表</div>
                <table className='table-sdklist' cellSpacing={0} cellPadding={0}>
                    <thead>
                        <tr>
                            <td>产品/类型</td>
                            <td>使用目的</td>
                            <td>使用场景</td>
                            <td>个人信息收集类型</td>
                            <td>收集方式</td>
                            <td>第三方公司名称</td>
                            <td>隐私保护说明</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>支付宝</th>
                            <th>可帮助用户完成付款、提供安全认证服务</th>
                            <th>支付宝登录、订单付款时</th>
                            <th>基础设备信息、app信息</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>支付宝（中国）网络技术有限公司</th>
                            <th><a href={'https://render.alipay.com/p/c/k2cx0tg8'} target={"_blank"} rel="noreferrer">支付宝隐私政策</a></th>
                        </tr>
                        <tr>
                            <th>微信</th>
                            <th>可帮助用户完成付款、提供安全认证服务</th>
                            <th>微信登录、订单付款和分享到微信时</th>
                            <th>基础设备信息、app信息</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>深圳市腾讯计算机系统有限公司</th>
                            <th><a href={'https://privacy.qq.com/document/priview/bdf936b2477a45ff86da57e3d988bc2b'} target={"_blank"} rel="noreferrer">腾讯隐私政策</a></th>
                        </tr>
                        <tr>
                            <th>环信</th>
                            <th>可用于客服为用户提供售前/售后咨询服务</th>
                            <th>打开客服聊天页面时</th>
                            <th>基础设备信息（AndroidID、设备硬件类型、设备型号、设备系统类型）、app信息</th>
                            <th>SDK本身采集，不涉及数据共享</th>
                            <th>北京亿思摩博网络科技有限公司</th>
                            <th><a href={'https://www.easemob.com/protocol'} target={"_blank"} rel="noreferrer">环信隐私政策</a></th>
                        </tr>
                    </tbody>
                </table>
            </>
        );
    }
}

export default LZPrivacySDKListPage;